import './form.scss'

/**
 * Show selected file name preview for single-file Gravity Forms uploads.
 *
 * The native file input is overlaid invisibly (opacity: 0) on the dropzone,
 * which means the browser's built-in "filename" feedback never appears.
 * This handler renders a visible preview after a file is chosen and provides
 * a clear button to reset the selection.
 */
( function( $ ) {
	const renderPreview = function( $input ) {
		const $container = $input.closest( '.ginput_container_fileupload' );

		if ( ! $container.length ) {
			return;
		}

		$container.find( '.js-fileUploadPreview' ).remove();
		$container.removeClass( '-hasFile' );

		const files = $input.prop( 'files' );

		if ( ! files || ! files.length ) {
			return;
		}

		const $preview = $( '<div class="ginput_preview js-fileUploadPreview" />' );

		Array.prototype.forEach.call( files, function( file ) {
			$preview.append( $( '<strong />' ).text( file.name ) );
		} );

		const $remove = $( '<a href="#" class="gform_delete js-fileUploadPreviewRemove" role="button" aria-label="Verwijder bestand">&times;</a>' );

		$remove.on( 'click', function( ev ) {
			ev.preventDefault();
			ev.stopPropagation();
			$input.val( '' );
			$preview.remove();
			$container.removeClass( '-hasFile' );
		} );

		$preview.append( $remove );
		$container.append( $preview );
		$container.addClass( '-hasFile' );
	};

	$( document ).on( 'change.themeFileUpload', '.ginput_container_fileupload input[type="file"]:not([multiple])', function() {
		renderPreview( $( this ) );
	} );
} )( jQuery );

/**
 * Handle Gravity Forms initialization in accordion.
 * Forms inside hidden containers don't calculate their height properly,
 * causing a "jump" when first opened.
 */
( function( $ ) {
	$( document ).ready( function() {
		const $formAccordion = $( '.o-form__items.js-accordion' );

		if ( ! $formAccordion.length ) {
			return;
		}

		// On mobile, briefly show all accordion content to let forms initialize,
		// then restore proper visibility
		const initHiddenForms = function() {
			// Only run on mobile (matches viewport-9 breakpoint)
			if ( window.innerWidth >= 992 ) {
				return;
			}

			const $hiddenContents = $formAccordion.find( '.js-accordionContent:hidden' );

			if ( ! $hiddenContents.length ) {
				return;
			}

			// Temporarily show hidden content off-screen to initialize forms
			$hiddenContents.each( function() {
				const $content = $( this );
				$content.css( {
					position: 'absolute',
					visibility: 'hidden',
					display: 'block',
					left: '-9999px'
				} );
			} );

			// Give forms time to initialize, then hide again
			setTimeout( function() {
				$hiddenContents.each( function() {
					const $content = $( this );
					$content.css( {
						position: '',
						visibility: '',
						display: 'none',
						left: ''
					} );
				} );

				// Trigger resize to finalize layout
				$( window ).trigger( 'resize' );
			}, 100 );
		};

		// Initialize hidden forms
		initHiddenForms();

		// Handle accordion toggle clicks
		$formAccordion.find( '.js-toggleAccordion' ).on( 'click', function() {
			const $content = $( this ).next( '.js-accordionContent' );

			// After slideToggle animation completes, trigger resize for Gravity Forms
			$content.promise().done( function() {
				$( window ).trigger( 'resize' );

				// If Gravity Forms conditional logic exists, trigger refresh
				if ( typeof gform !== 'undefined' && typeof gform.doAction === 'function' ) {
					gform.doAction( 'gform_post_conditional_logic' );
				}
			} );
		} );
	} );
} )( jQuery );